import { Card, CardHeader, CardTitle, CardBody } from '@vnetwork/ui/primitives';
import type { DrmStream } from '@/api/aes';
import { fmtDuration } from '../shared';
import styles from '../Drm.module.css';

/** Identity + addressing facts for a stream, surfaced on every tab via the rail. */
export function StreamSummaryCard({ stream }: { stream: DrmStream }) {
  const isLive = stream.kind === 'live';
  return (
    <Card flat className={styles.blockGap}>
      <CardHeader>
        <CardTitle className={styles.cardTitle}>Stream details</CardTitle>
      </CardHeader>
      <CardBody>
        <dl className={styles.facts}>
          <dt className={styles.factLabel}>Encryption</dt>
          <dd className={styles.factValue}>HLS AES-128</dd>

          <dt className={styles.factLabel}>Shard</dt>
          <dd className={styles.factValue}>{stream.shard ?? 'unassigned'}</dd>

          <dt className={styles.factLabel}>DVR window</dt>
          <dd className={styles.factValue}>{fmtDuration(stream.dvr_seconds)}</dd>

          {isLive ? (
            <>
              <dt className={styles.factLabel}>Key period</dt>
              <dd className={styles.factValue}>{stream.period_secs}s</dd>
            </>
          ) : null}

          <dt className={styles.factLabel}>Renditions</dt>
          <dd className={styles.factValue}>{stream.abr_ladder?.length ?? 0}</dd>

          <dt className={styles.factLabel}>Source</dt>
          <dd className={styles.factValue}>
            <code className={styles.factMono}>{stream.source_url}</code>
          </dd>
        </dl>
      </CardBody>
    </Card>
  );
}
